import has from 'lodash/has'
import { Line } from 'vue-chartjs'
import CharConfig from './chartConfig'

export default Line.extend({
  name: 'line-chart',
  props: {
    data: {
      type: Object,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const Options = new CharConfig()

    if (has(this.data, 'title')) {
      Options.showTitle(this.data.title)
    }

    Options.scales = {
      xAxes: [{
        barThickness: 73,
        display: true,
        position: 'bottom',
        categorySpacing: 0,
        ticks: {
          fontFamily: 'DroidSans',
        },
        scaleLabel: has(this.data, 'xAxisLabel') ? {
          display: true,
          labelString: this.data.xAxisLabel,
          fontFamily: 'DroidSans',
        } : {},
      }],
      yAxes: [{
        type: 'linear',
        display: true,
        position: 'left',
        ticks: {
          fontFamily: 'DroidSans',
        },
        scaleLabel: has(this.data, 'yAxisLabel') ? {
          display: true,
          labelString: this.data.yAxisLabel,
          fontFamily: 'DroidSans',
        } : {},
      }],
    }

    this.data.datasets[0].fill = false

    this.renderChart(this.data, Options)
  },
})



// WEBPACK FOOTER //
// ./components/chart/LineChart.js